import { jsx } from 'react/jsx-runtime';

const SvgActionBugFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M4 18h2.35a6 6 0 0 0 11.3 0H20v3h2v-5h-4v-4h4V7h-2v3h-2a6 6 0 0 0-1.74-4.22l1-2.78h-2.12l-.57 1.58a6 6 0 0 0-5.14 0L8.86 3H6.73l1 2.78A6 6 0 0 0 6 10H4V7H2v5h4v4H2v5h2v-3Zm8-.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm1-4h-2V9h2v4.5Z" }) }));

export { SvgActionBugFill as default };
//# sourceMappingURL=ActionBugFill.es.js.map
